import dayjs from "dayjs";


export type typeStatusExecucao = {
    status: string,
    color_light: string,
    cor: string,
    descricao: 'Adiantada' | 'No prazo' | 'Atrasada' | 'Indefinido'
};

/** Compara o **fim da execução** com o prazo planejado e retorna o status de cumprimento.
 *
 * Usada tanto na linha do tempo (selo de `Prazo`) quanto nos relatórios de
 * atividades executadas (coluna `Pontualidade`).
 *
 * A comparação é feita por dia (ignora hora/timezone), pois as datas podem chegar
 * como `YYYY-MM-DD` (atividade) ou ISO com hora (andamento).
 *
 * @param data_inicial início do prazo planejado
 * @param data_final fim do prazo planejado — quando ausente, o prazo é o próprio dia de início
 * @param DATA_EXECUCAO data em que a execução **terminou**
 */
export function obterStatusExecucao(data_inicial?: string | null, data_final?: string | null, DATA_EXECUCAO?: string | null): typeStatusExecucao {

    const indefinido: typeStatusExecucao = { status: 'Indefinido', color_light: 'lightgray', cor: 'lightgray', descricao: 'Indefinido' };

    if (!data_inicial || !DATA_EXECUCAO) {
        return indefinido;
    }

    let data_prazo_inicial = dayjs(data_inicial).startOf('day');
    let data_prazo_final = dayjs(data_final ?? data_inicial).startOf('day');
    let data_execucao = dayjs(DATA_EXECUCAO).startOf('day');

    if (!data_prazo_inicial.isValid() || !data_prazo_final.isValid() || !data_execucao.isValid()) {
        return indefinido;
    }

    let is_adiantado = data_execucao.isBefore(data_prazo_inicial);
    let is_atrasado = data_execucao.isAfter(data_prazo_final);

    /**dias de distância até a extremidade do prazo que foi rompida */
    let diferenca_dias = Math.abs(is_adiantado
        ? data_prazo_inicial.diff(data_execucao, 'day')
        : data_prazo_final.diff(data_execucao, 'day'));
    let dias = diferenca_dias === 1 ? 'dia' : 'dias';

    if (is_adiantado) {
        return { status: `${diferenca_dias} ${dias} Adiantado`, color_light: 'rgba(255, 172, 0, 0.2)', cor: '#cb9700', descricao: 'Adiantada' }
    }
    if (is_atrasado) {
        return { status: `${diferenca_dias} ${dias} Atrasado`, color_light: 'rgba(220, 20, 60, 0.1)', cor: '#DC143C', descricao: 'Atrasada' }
    }

    return { status: `No prazo`, color_light: 'rgba(41, 233, 34, 0.07)', cor: '#29e922', descricao: 'No prazo' }
}
